import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { formatDistanceToNow, format } from "date-fns";
import type { PageType, SignalScore } from "@/types";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function timeAgo(date: string | Date): string {
  return formatDistanceToNow(new Date(date), { addSuffix: true });
}

export function formatDate(date: string | Date): string {
  return format(new Date(date), "MMM d, yyyy");
}

export function formatDateTime(date: string | Date): string {
  return format(new Date(date), "MMM d, yyyy 'at' h:mm a");
}

export function signalScoreLabel(score: SignalScore): string {
  return { high: "High", medium: "Medium", low: "Low" }[score];
}

export function signalScoreColor(score: SignalScore): string {
  return {
    high: "text-red-500",
    medium: "text-amber-500",
    low: "text-blue-500",
  }[score];
}

export function signalScoreBadgeVariant(score: SignalScore): "high" | "medium" | "low" {
  return score as "high" | "medium" | "low";
}

export function pageTypeLabel(type: PageType): string {
  return {
    pricing: "Pricing",
    features: "Features",
    changelog: "Changelog",
    blog: "Blog",
    careers: "Careers",
    docs: "Docs",
    homepage: "Homepage",
    custom: "Custom",
  }[type];
}

export function pageTypeIcon(type: PageType): string {
  return {
    pricing: "💰",
    features: "✨",
    changelog: "📋",
    blog: "📝",
    careers: "💼",
    docs: "📚",
    homepage: "🏠",
    custom: "🔗",
  }[type];
}

export function getDomainFromUrl(url: string): string {
  try {
    return new URL(url).hostname.replace(/^www\./, "");
  } catch {
    return url;
  }
}

export function getFaviconUrl(domain: string): string {
  return `https://www.google.com/s2/favicons?domain=${domain}&sz=32`;
}
